var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
import { forwardRef } from "react";
var SvgTimeline = function SvgTimeline(props, ref) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    fill: "none",
    viewBox: "0 0 24 24",
    xmlns: "http://www.w3.org/2000/svg",
    ref: ref
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    stroke: "#323232",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1.5,
    d: "M13.125 14.812a1.687 1.687 0 1 1 1.687 1.687 1.679 1.679 0 0 1-1.687-1.674v-.013ZM13.62 13.62l-3.24-3.24M16.01 13.62l3.23-3.24M10.875 9.188A1.687 1.687 0 1 1 9.188 7.5a1.679 1.679 0 0 1 1.687 1.674v.014ZM4.76 13.62l3.23-3.24M22.125 9.188a1.687 1.687 0 1 1-3.375 0 1.687 1.687 0 0 1 3.375 0v0ZM1.875 14.812a1.687 1.687 0 1 1 .001.013l-.001-.013v0Z"
  })));
};
var ForwardRef = /*#__PURE__*/forwardRef(SvgTimeline);
export default ForwardRef;